import 'selectize';

import '../select-plugins/clear_selection';

// Select que busca no servidor por digitacao, em vez de trazer a lista inteira
// no HTML. O primeiro caso foi o motorista da modal da ST: 1.918 `<option>` num
// `<select>` so (de 2.437 na pagina) travavam o navegador, enquanto o servidor
// respondia em 113ms.
//
// A URL vem em `data-url` e a resposta e `{ items: [{ value, text }], total }`.
// `total` existe para avisar quando ha resultado alem do lote - dropdown nao
// pagina: quem procura digita mais letras.
const MIN_QUERY_LENGTH = 2;

function clearNotice(selectize) {
  selectize.$dropdown.find('.selectize-remote-summary').remove();
}

function showNotice(selectize, text, cssClass) {
  clearNotice(selectize);

  selectize.$dropdown.append(
    $(
      `<div class="selectize-remote-summary px-2 py-1 small ${cssClass}"></div>`
    ).text(text)
  );
}

function showSummary(selectize, shown, total) {
  if (total <= shown) {
    clearNotice(selectize);
    return;
  }

  showNotice(
    selectize,
    `mostrando ${shown} de ${total} — digite mais para refinar`,
    'text-muted'
  );
}

export default function remoteSelectize() {
  $('select.selectize-remote').each((_i, elem) => {
    const $elem = $(elem);
    if ($elem[0].selectize) {
      return;
    }

    const url = $elem.data('url');

    $elem.selectize({
      selectOnTab: true,
      plugins: { clear_selection: {} },
      valueField: 'value',
      labelField: 'text',
      searchField: 'text',
      // O servidor ja filtra e ordena por nome; sem isto o selectize reordena
      // por score e embaralha o que o usuario acabou de ver chegar.
      score: () => () => 1,
      load(query, callback) {
        // O abort vem ANTES do corte por tamanho: apagando letras ate ficar
        // abaixo do minimo, a requisicao da consulta maior continuava em voo e
        // repopulava o dropdown de uma busca que o usuario acabou de apagar.
        if (this.remoteXhr) {
          this.remoteXhr.abort();
        }

        if (!url || query.length < MIN_QUERY_LENGTH) {
          clearNotice(this);
          return callback();
        }

        // Um request por digitacao, sem ordem garantida de resposta: a resposta
        // de 'jo' chegando depois da de 'joao' sobrescrevia o resultado mais
        // estreito. Mesma corrida que o `preXhr.dt` de custom_datatable.js
        // aborta para os datatables. `loadThrottle` do selectize so espaca os
        // requests, nao ordena as respostas.
        this.remoteXhr = $.getJSON(url, { search: query })
          .done((res) => {
            // Corpo fora do contrato `{ items, total }` (pagina de erro com 200,
            // resposta em array, proxy no meio) caia em `[]` e ficava igual a
            // "nao existe motorista com esse nome" - o operador seguia e salvava
            // a ST sem motorista, que e o caso que o `.fail` abaixo existe para
            // evitar.
            if (!res || !Array.isArray(res.items)) {
              callback();
              showNotice(
                this,
                'Falha ao buscar. Tente de novo.',
                'text-danger'
              );
              return;
            }

            const { items } = res;
            // `score` acima desliga o filtro do selectize, entao sem limpar as
            // opcoes o dropdown acumulava os resultados de todos os prefixos
            // digitados. `clearOptions` preserva a opcao do item selecionado.
            this.clearOptions();
            callback(items);
            showSummary(this, items.length, res.total || items.length);
          })
          .fail((xhr, status) => {
            callback();

            // Sem isto um 500 ou timeout ficava igual a "nao existe motorista
            // com esse nome" - o operador seguia e salvava a ST sem motorista.
            if (status !== 'abort') {
              showNotice(
                this,
                'Falha ao buscar. Tente de novo.',
                'text-danger'
              );
            }
          });

        return this.remoteXhr;
      },
    });
  });
}
